import { Logger } from '@frontend/logger';
import { useEffect } from 'react';

import AppRoutes from './app-routes';
import AdminAppShell from './app-shell/app-shell.component';

export function App() {
    useEffect(() => {
        cleanupStaleResolverKeys();
    }, []);

    return (
        <AdminAppShell>
            <AppRoutes />
        </AdminAppShell>
    );
}
export default App;

function cleanupStaleResolverKeys() {
    try {
        // Clean up stale resolver keys that may have been left behind
        const resolverKeys = ['dcm_res', 'dcm_res_loading'];
        const requestLoadingPattern = /^[^_]+_REQ(_loading)?$/;

        const keys = Object.keys(localStorage);
        const keysToRemove = keys.filter((key) => resolverKeys.includes(key) || requestLoadingPattern.test(key));

        keysToRemove.forEach((key) => {
            localStorage.removeItem(key);
        });

        if (keysToRemove.length > 0) {
            Logger.log(`Cleaned up ${keysToRemove.length} stale resolver keys from localStorage`);
        }
    } catch (error) {
        Logger.error('Error cleaning up stale resolver keys:', error);
    }
}
